import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { ProductEntity } from '../entities/product.entity';
import { State } from '../State';
import { getProducts } from '../State/selectors/products.selectors';
import { ResolverLoadProducts } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root'
})
export class ProductResolver implements Resolve<ProductEntity[]> {
    constructor(private store: Store<State>) {
    }

    resolve() {
        const value$ = this.store.select(getProducts);

        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(new ResolverLoadProducts());
                    }}
                )
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
